import {ReactNode} from 'react';
// One path per icon, never the barrel: the menu's test loads this module, and through the barrel
// it took 56 s where the paths take under a second.
import AdminIcon from '@mui/icons-material/AdminPanelSettings';
import DocsIcon from '@mui/icons-material/Description';
import ProjectsIcon from '@mui/icons-material/FolderOpen';
import PendingIcon from '@mui/icons-material/PendingActions';
import SearchIcon from '@mui/icons-material/Search';
import ParametersIcon from '@mui/icons-material/Tune';

export interface MenuItem {
    text: string;
    path: string;
    icon: ReactNode;
    title: string;
    subtitle: string;
    /** Shown only while «Hide unused» is off. */
    hidden?: boolean;
    /** The SuccessBuilder team's alone: the platform role's (SB-322). */
    platform?: boolean;
}

export const menuItems: MenuItem[] = [
    {text: 'Adressesøk', path: '/address-search', icon: <SearchIcon/>, title: 'Adressesøk', subtitle: 'Søk etter en eiendomsadresse for å sjekke byggesamsvar mot lokale forskrifter'},
    {text: 'Søknader', path: '/ude/projects', icon: <ProjectsIcon/>, title: 'Søknader', subtitle: 'Last opp tegninger og kjør samsvarssjekk mot byggeforskrifter'},
    {text: 'Parameters', path: '/parameters', icon: <ParametersIcon/>, title: 'Parameters Registry', subtitle: 'Define and manage building parameters used for compliance checking', hidden: true, platform: true},
    {text: 'Doc Processing', path: '/pending-docs', icon: <PendingIcon/>, title: 'Doc Processing', subtitle: 'Upload, extract, and review PDF documents for the regulation database', hidden: true, platform: true},
    {text: 'Documentation', path: '/docs', icon: <DocsIcon/>, title: 'Documentation Browser', subtitle: 'Browse ingested regulation documents and their sections', hidden: true},
    // Until SB-401 the admin page had no way in but its address.
    {text: 'Admin', path: '/admin', icon: <AdminIcon/>, title: 'Admin', subtitle: 'User feedback, address data, the plan index, regulation gaps and the LLM calls', platform: true},
];

/** The entries the sidebar shows: a platform entry only to the platform role, and a hidden one
 *  only while «Hide unused» is off. The API's 403 is the guard; this keeps the entry off a
 *  customer's screen. */
export function menuFor(isPlatform: boolean, hideUnused: boolean): MenuItem[] {
    return menuItems.filter(item => (isPlatform || !item.platform) && (!hideUnused || !item.hidden));
}
